// Fetch list

export const FETCH = 'customerPlans.FETCH'
export const FETCH_STARTED = 'customerPlans.FETCH_STARTED'
export const FETCH_FULFILLED = 'customerPlans.FETCH_FULFILLED'
export const FETCH_REJECTED = 'customerPlans.FETCH_REJECTED'
export const FETCH_CANCELLED = 'customerPlans.FETCH_CANCELLED'

export const SORTING_CHANGED = 'customerPlans.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'customerPlans.FETCH_ONE'
export const FETCH_ONE_STARTED = 'customerPlans.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'customerPlans.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'customerPlans.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'customerPlans.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'customerPlans.SAVE'
export const SAVE_STARTED = 'customerPlans.SAVE_STARTED'
export const SAVE_FULFILLED = 'customerPlans.SAVE_FULFILLED'
export const SAVE_REJECTED = 'customerPlans.SAVE_REJECTED'
export const SAVE_CANCELLED = 'customerPlans.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'customerPlans.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'customerPlans.DELETE'
export const DELETE_STARTED = 'customerPlans.DELETE_STARTED'
export const DELETE_FULFILLED = 'customerPlans.DELETE_FULFILLED'
export const DELETE_REJECTED = 'customerPlans.DELETE_REJECTED'
export const DELETE_CANCELLED = 'customerPlans.DELETE_CANCELLED'

// Export

export const EXPORT = 'customerPlans.EXPORT'
export const EXPORT_FULFILLED = 'customerPlans.EXPORT_FULFILLED'
